module.exports = __webpack_public_path__ + "static/media/traffic-light-slow.1b006a1e.svg";